import OneColumnsSection from "./OneColumnsSection";

export default OneColumnsSection;
